import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiGrid from '@material-ui/core/Grid';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import MuiSwitch from '@material-ui/core/Switch';
import ViewWrapper from 'views/ViewWrapper';

import ReportFilesTableContainer from './ReportFilesTableContainer';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
  toggleLabel: {
    marginRight: 0,
  },
  startLabel: {
    marginRight: theme.spacing(1),
  },
  endLabel: {
    marginLeft: theme.spacing(0.5),
  },
});

function ReportFiles({ classes }) {
  const [showIsIngested, setShowIsIngested] = useState(false);

  const handleShowIsIngestedChanged = e => {
    setShowIsIngested(!e.target.checked);
  };

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            Report Files
          </MuiTypography>
          <div className={classes.actionRow}>
            <div className={classes.vCenter}></div>
            <div>
              <span className={classes.startLabel}>Ingested</span>
              <MuiFormControlLabel
                className={classes.toggleLabel}
                control={
                  <MuiSwitch
                    checked={!showIsIngested}
                    onChange={handleShowIsIngestedChanged}
                    name="showIsIngested"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                }
              />
              <span className={classes.endLabel}>Not Ingested</span>
            </div>
          </div>
          <ReportFilesTableContainer filters={{ showIsIngested }} />
        </MuiPaper>
      </MuiGrid>
    </ViewWrapper>
  );
}

ReportFiles.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ReportFiles);
